export class AccessibilityEnhancements {
  constructor() {
    this.init();
  }

  public refresh(): void {
    this.applySectionLabels();
  }

  private init(): void {
    this.focusCurrentHashTarget();
    window.addEventListener('hashchange', this.handleHashChange);
    this.applySectionLabels();
  }

  private handleHashChange = (): void => {
    const hash = window.location.hash;

    if (!hash || hash === '#') {
      const header = document.getElementById('header');
      if (header) {
        this.focusElementTemporarily(header);
      }
      return;
    }

    this.focusCurrentHashTarget();
  };

  private focusCurrentHashTarget(): void {
    const hash = window.location.hash;
    if (!hash || hash === '#') return;

    const target = document.querySelector(hash) as HTMLElement | null;
    if (target) {
      this.focusElementTemporarily(target);
    }
  }

  private focusElementTemporarily(element: HTMLElement): void {
    element.setAttribute('tabindex', '-1');

    const removeTabIndex = (): void => {
      element.removeAttribute('tabindex');
      element.removeEventListener('blur', removeTabIndex);
      element.removeEventListener('focusout', removeTabIndex);
    };

    element.addEventListener('blur', removeTabIndex);
    element.addEventListener('focusout', removeTabIndex);
    element.focus();
  }

  private applySectionLabels(): void {
    const sections = document.querySelectorAll('section');

    sections.forEach((section, index) => {
      const firstHeading = section.querySelector('h1, h2, h3, h4, h5, h6') as HTMLElement | null;
      if (!firstHeading) return;

      if (!firstHeading.id) {
        firstHeading.id = `sectionHeading-${index + 1}`;
      }

      section.setAttribute('aria-labelledby', firstHeading.id);
    });
  }
}